export default "__VITE_ASSET__DmZlWift__"